import { Entity } from './../../graphql/interfaces/entityModel';
import { EntityService } from 'app/graphql/services/entity.service';
import { GetPublicEntity } from './../actions/entity.actions';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable, Inject, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { StorageService } from '@shared/services/secure-storage.service';
import { TypeService } from 'app/graphql/services/type.service';
import { TypesModel } from 'app/graphql/interfaces/typesModel';
import { SetBreadcrumbDetail, SetTitle } from '../actions/settings.actions';

export interface SettingsStateModel {
  breadcrumbDetail: String;
  title: String;
}

@Injectable()
@State<SettingsStateModel>({
  name: 'Settings',
  defaults: {
    breadcrumbDetail: null,
    title: null,
  },
})
export class SettingsState {
  constructor(
    private entityService: EntityService,
    private typeService: TypeService,
    public ngZone: NgZone,
    public router: Router,
    public storageService: StorageService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  @Selector()
  static breadcrumbDetail(state: SettingsStateModel) {
    return state.breadcrumbDetail;
  }

  @Selector()
  static title(state: SettingsStateModel) {
    return state.title;
  }

  @Action(SetBreadcrumbDetail)
  setBreadcrumbDetail(
    { patchState, getState, dispatch }: StateContext<SettingsStateModel>,
    payload: SetBreadcrumbDetail
  ) {
    patchState({
      breadcrumbDetail: payload.detail,
    });
  }

  @Action(SetTitle)
  SetTitle(
    { patchState, getState, dispatch }: StateContext<SettingsStateModel>,
    payload: SetTitle
  ) {
    patchState({
      title: payload.title,
    });
  }
}
